import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import './top-menu.scss';

import { Languages, MenuItems } from './top-menu';
import LI from '../html-tags/li';
import { ShowcasesMenuItems } from '../../showcases/showcases-menu';

// Assuming UC_UI is a global object, you can declare it like this:
declare const UC_UI: { showSecondLayer: () => void };

export type Props = {
  selected?: MenuItems;
  menuName: MenuItems | ShowcasesMenuItems;
  labels: { language: Languages; label: string }[];
  submenu?: () => JSX.Element;
};

const MenuItem: FunctionComponent<Props> = (props) => {
  const history = useNavigate();

  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  return (
    <>
      {props.labels
        .filter((x) => window.location.href.indexOf('/' + x.language + '/') !== -1)
        .map((languageInfo) => (
          <LI
            key={languageInfo.language}
            language={languageInfo.language}
            className={props.selected === props.menuName ? 'selected' : ''}
          >
            {props.menuName === 'cookies' ? (
              <button
                type="button"
                onClick={() => UC_UI.showSecondLayer()}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  color: 'inherit',
                  fontSize: '0.8rem',
                  cursor: 'pointer',
                }}
              >
                {languageInfo.label}
              </button>
            ) : (
              <a
                href={'/' + languageInfo.language + '/' + props.menuName}
                onClick={(e) => {
                  e.preventDefault();
                  history('/' + languageInfo.language + '/' + props.menuName);
                }}
              >
                <span>{languageInfo.label}</span>
              </a>
            )}
            {props.submenu && <div className="drop-down-menu">{props.submenu()}</div>}
          </LI>
        ))}
    </>
  );
};

export default MenuItem;
